export default function PhotoGallery() {
  return <h1>PhotoGallery</h1>;
}
